export const getFormattedDate = (): string => {
  const now = new Date();
  const hour = now.getHours();

  // AM 3:00 より前の場合は前日の日付を取得
  if (hour < 3) {
    now.setDate(now.getDate() - 1);
  }

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 月（0始まりなので+1）
  const day = String(now.getDate()).padStart(2, "0"); // 日

  return `${year}${month}${day}`;
};

export const getDateForView = (dateString: string): string => {
  if (!/^\d{8}$/.test(dateString)) {
    throw new Error("Invalid date format. Expected YYYYMMDD.");
  }

  const year = dateString.slice(0, 4);
  const month = parseInt(dateString.slice(4, 6), 10); // 先頭のゼロを削除
  const day = parseInt(dateString.slice(6, 8), 10);

  const date = new Date(
    `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}`
  );

  const weekdays = ["日", "月", "火", "水", "木", "金", "土"];
  const weekday = weekdays[date.getDay()];

  return `${year}年${month}月${day}日(${weekday})`;
};
